import axios from 'axios';
import config from '@/config';
import store from './../index';

const alertEndpoint = `${config.API_URL}/Alerts`;

export const getAlerts = (_, { pageNumber, pageSize, manager, monitoring, search, isRead, year }) =>
  new Promise((resolve, reject) =>
    axios
      .get(
        `${alertEndpoint}?${pageSize ? `pageSize=${pageSize}` : ``}${pageNumber ? `&pageNumber=${pageNumber}` : ``}${
          manager ? `&ManagerPublicId=${manager}` : ``
        }${monitoring ? `&PackageLevelPublicId=${monitoring}` : ``}${isRead ? `&IsRead=${isRead === 'Lu'}` : ``}${
          year && year !== 'Toutes' ? `&year=${year}` : ``
        }${search ? `&Search=${search}` : ``}`,
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const toggleAlertRead = (_, { id }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(`${alertEndpoint}/${id}`, {}, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const exportAlerts = () =>
  new Promise((resolve, reject) =>
    axios
      .get(`${alertEndpoint}/export`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response))
      .catch(reject),
  );
